import React, { ReactElement } from 'react';
import { qaAttribute } from '../utils/qa-service';
import { infoBoxCss } from './info-box.style';
import IconLightbulb from './img/icon-bulb.svg';
import Icon from '../icon/icon';

const InfoBox = ({
    children,
    type = 'default',
    classNames,
    extraCss,
    id,
    iconType,
    canClose,
    canCloseAction,
    title,
    dataQ,
}: {
    children: any;
    type?: InfoBoxType;
    classNames?: string;
    extraCss?: any;
    canClose?: boolean;
    canCloseAction?: any;
    iconType?: string;
    title?: string;
    id?: string;
    dataQ?: string;
}): ReactElement => {
    return (
        <div
            className={`info-box ${type}-info-box ${classNames ?? ''}`}
            id={id}
            css={[infoBoxCss, extraCss]}
        >
            {type === 'hint' ? (
                <IconLightbulb />
            ) : type === 'default' ? (
                <span className="icon icon--info-outline" aria-hidden="true" />
            ) : iconType ? (
                <span className={`icon icon--${iconType}`} aria-hidden="true" />
            ) : (
                <></>
            )}
            <div {...(dataQ && { ...qaAttribute(`${dataQ}`) })}>
                {title && <b className="info-box-title">{title}</b>}
                {children}
            </div>
            {canClose && (
                <Icon className="box-close-icon" type="close-alt" onClick={canCloseAction} />
            )}
        </div>
    );
};

type InfoBoxType = 'default' | 'borderless' | 'price' | 'hint' | 'confirmation' | '';

export default InfoBox;
